export const config = () => {
    return {
        region: "us-east-1",
        userPoolId: "us-east-1_52z0FE4gI",
        userPoolWebClientId: "2tss9q2ta2gssbn5hctq0pdh06",
    }
}